import React, { useEffect } from "react";
import "./Footer.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { TbBrandWhatsappFilled } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchFooterData } from  "../../redux/slices/FooterSlice";

const Footer = () => {
  const { t } = useTranslation("global");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { data: footerData, isLoading, error } = useSelector(
    (state) => state.footer
  );

  useEffect(() => {
    dispatch(fetchFooterData());
  }, [dispatch]);

  const scrollToSection = (id) => {
    if (location.pathname === "/") {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };
  console.log(footerData)

  return (
    <footer className="footer py-5 text-white" id="footer">
      <div className="container">
        <div className="row">
          {/* Logo and Description */}
          <div className="col-xl-4 col-lg-4 col-md-6 col-12 mb-4">
            <Link to="/">
              <img
                className="footer_logo"
                src="/nile-white.png"
                alt={t("navbar.home")}
              />
            </Link>
            <p className="line-height text-center">
              {footerData?.description || t("footer.description")}
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-xl-4 col-lg-4 col-md-6 col-12 mb-4">
            <h5>{t("footer.quickLinks")}</h5>
            <ul className="list-unstyled quick_links">
              <li>
                <Link to="/" className="footer-link">
                  {t("navbar.home")}
                </Link>
              </li>
              <li>
                <a
                  href="#about"
                  className="footer-link"
                  onClick={() => scrollToSection("about")}
                >
                  {t("navbar.about")}
                </a>
              </li>
              <li>
                <a
                  href="#our_products"
                  className="footer-link"
                  onClick={() => scrollToSection("our_products")}
                >
                  {t("navbar.products")}
                </a>
              </li>
              <li>
                <a
                  href="#footer"
                  className="footer-link"
                  onClick={() => scrollToSection("footer")}
                >
                  {t("navbar.contact")}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-xl-4 col-lg-4 col-md-6 col-12 mb-4">
            <h5>{t("footer.contactUs")}</h5>
            <p>
              <FaMapMarkerAlt className="me-2" />
              {footerData?.address }
            </p>

            <p>
              <TbBrandWhatsappFilled className="me-2" />
              <a
                href={`https://wa.me/${footerData?.whats_one }`}
                target="_blank"
                rel="noopener noreferrer"
                className="d-inline-block text-white"
                style={{
                  direction: "ltr",
                  color: "white",
                }}
              >
                {footerData?.whats_one }
              </a>
            </p>

            <p>
              <TbBrandWhatsappFilled className="me-2" />
              <a
                href={`https://wa.me/${footerData?.whats_two}`}
                target="_blank"
                rel="noopener noreferrer"
                className="d-inline-block text-white"
                style={{
                  direction: "ltr",
                  color: "white",
                }}
              >
                {footerData?.whats_two }
              </a>
            </p>

            <p className="custom-font">
              <FaEnvelope className="me-2" />
              <a
              className="text-white"
                href={`mailto:${footerData?.email}`}
                style={{ color: "var(--basic-color)" }}
              >
                {footerData?.email}
              </a>
            </p>
          </div>
        </div>

        <div className="text-center mt-4 border-top pt-3">
          <small>
            © {new Date().getFullYear()} Nile Gate Export. {t("footer.rights")}
            <a
              style={{ color: "var(--sub-color)" }}
              href="https://brmja.tech/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
            >
              {" "}
              {t("footer.brmjaTech")}
            </a>
          </small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
